import pick from 'lodash/pick';

import { createContexts } from '../../utils';

import type { EventDefinition } from '../../types';

export const data_sync_auth_modified: EventDefinition = {
  getData: (_, eventData = {}) => ({
    ...pick(eventData, ['firstTimeSetup']),
  }),
  addContexts: ({ eventData } = {}) =>
    createContexts(['integration'], {
      eventData: {
        integration: { slug: eventData?.slug },
      },
    }),
};
